export const FETCH_COURSE_DETAIL_INITIAL = "FETCH_COURSE_DETAIL_INITIAL";
export const FETCH_COURSE_DETAIL_SUCCESS = "FETCH_COURSE_DETAIL_SUCCESS";
export const FETCH_COURSE_DETAIL_FAILURE = "FETCH_COURSE_DETAIL_FAILURE";


